import React, { useContext, useState, useEffect } from "react";
import cn from "classnames";
import { ContextProfileUser } from "../../lib/profileContext";

import "./EmailForm.scss";

import ButtonSubmit from "../ButtonSubmit";
import InputGlobal from "../InputGlobal";
import Tooltip from "../Tooltip";
import LoaderEmail from "../LoaderEmail/index";
import ProgressDots from "../ProgressDots/ProgressDots";

import { simplyClick, validateEmail } from "../../helpers";
import {
  errorEventsEmail,
  landingId,
  ERROR_EMAIL_ALREADY_USED,
} from "../../constants";

const EmailForm = ({ nextStep }) => {
  const [errorEmail, setErrorEmail] = useState(null);
  const [loader, setLoader] = useState(false);
  const { data, setData } = useContext(ContextProfileUser);
  const [showTooltip, setShowTooltip] = useState(false);
  const [loaderText, setLoaderText] = useState({
    main: "",
    sub: "",
  });

  useEffect(() => {
    const fromLogin = sessionStorage.getItem("fromLogin");
    const savedEmail = sessionStorage.getItem("email");

    if (fromLogin === "1" && savedEmail && !data.email) {
      setData((prev) => ({
        ...prev,
        email: savedEmail,
      }));
    }
    sessionStorage.removeItem("fromLogin");
  }, []);

  const handlerSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    setLoaderText({
      main: "Verifying your email...",
      sub: "This might take a moment.",
    });

    const textTimeout = setTimeout(() => {
      setLoaderText({
        main: "Still verifying your email...",
        sub: "Thanks for your patience!",
      });
    }, 3000);

    validateEmail(data.email, (result) => {
      clearTimeout(textTimeout);
      setLoader(false);
      setLoaderText({
        main: "",
        sub: "",
      });
      const { status, error } = result;
      setLoader(false);
      if (!status && error) {
        const analyticsEvent = errorEventsEmail[error];
        if (analyticsEvent) {
          simplyClick(analyticsEvent);
        }
        setErrorEmail(error);
        return;
      }
      simplyClick("cl_lnd_email_st11_action", { text: "next" });
      nextStep();
      sessionStorage.removeItem("email");
    });
  };

  const handleAddEmail = ({ target: { value } }) => {
    setEmailValue(value);
  };

  const setEmailValue = (value) => {
    setErrorEmail(null);
    setShowTooltip(false);
    setData({ ...data, email: value });
  };

  return (
    <>
      {loader && (
        <LoaderEmail textMain={loaderText.main} textSub={loaderText.sub} />
      )}
      <div className="email__form-wrapper">
        <div className="user__form-top">
          <h3>My email</h3>
        </div>
        <form
          className="form__email"
          onSubmit={handlerSubmit}
          autoComplete="on"
          noValidate={true}
        >
          <div className="input__wrapper">
            <InputGlobal
              onChange={(e) => handleAddEmail(e)}
              placeholder={"Enter your real email address"}
              className={cn("input__global", "input__email", {
                input__error: errorEmail,
              })}
              name={"email"}
              type={"email"}
              value={data.email || ""}
              autoComplete="email"
              onFocus={() => {
                if (!data.email || data.email.trim() === "") {
                  setShowTooltip(true);
                } else {
                  setShowTooltip(false);
                }
                simplyClick("cl_lnd_email_st11_type_email", {
                  text: "type_email",
                });
              }}
              onBlur={() => setShowTooltip(false)}
            />
            <Tooltip
              text="We'll use this email for account verification and important notifications."
              showTooltip={showTooltip}
              className="email"
            />
          </div>

          {errorEmail && (
            <p className="errorEmail">
              {errorEmail === ERROR_EMAIL_ALREADY_USED
                ? "This email is already registered"
                : errorEmail}
            </p>
          )}
          {errorEmail === ERROR_EMAIL_ALREADY_USED && (
            <div className="extra-info">
              <p>
                <a
                  href={`/login/?landing_id=${landingId}${
                    data?.email
                      ? `&email=${encodeURIComponent(data.email)}`
                      : ""
                  }`}
                  id="login-link"
                  onClick={() => {
                    sessionStorage.setItem("email", data.email);
                    sessionStorage.setItem("fromLogin", "1");
                    simplyClick("cl_lnd_email_st11_log_in", { text: "log_in" });
                  }}
                >
                  Log in
                </a>
                &nbsp;or use another email.
              </p>
            </div>
          )}

          <ButtonSubmit
            className={"button__global button__email"}
            text={"NEXT"}
          />
          <ProgressDots total={12} activeCount={11} />
        </form>
      </div>
    </>
  );
};

export default EmailForm;
